import { useState } from 'react';
import LoginSendOtp from './send-otp';
import LoginVerifyOtp from './verify-otp';

function LoginByMobile({ t, setAuth }) {
  const [show, setShow] = useState('sendotp');
  return (
    <section className='mt-3 sm:mt-5'>
      {show === 'sendotp' ? (
        <LoginSendOtp {...{t, setAuth, setShow}} />
      ) : (
        <LoginVerifyOtp {...{t, setAuth, setShow}} />
      )}
    </section>
  );
}

export default LoginByMobile;
